import { Flex, Input } from "@chakra-ui/react"
import Icon from "components/UI/atoms/Icon"
import { ISearchInputProps } from "./SearchInputTypes"
import styled from "@emotion/styled"


const StyledFlex = styled(Flex)`
  border: 2px solid var(--chakra-colors-input_border_color_primary);
  border-radius: 10px;
  :focus-within {
    border: 2px solid #08ba36;
  }
`

const SearchInput: React.FC<ISearchInputProps> = ({ value, onChange, onSearchClick }) => {
    return (<>
        <StyledFlex>
            <Input
                id="bookings-searchbar"
                name="bookings"
                value={value}
                onChange={onChange}
                type="string"
                style={{ width: "114px", height: "40px", border: "none", outline: "none" }}
            />
            <Flex onClick={onSearchClick} alignItems={"center"} justifyContent="center" height={"40px"} padding={"6px"}>
                <Flex alignItems={"center"} justifyContent="center" h={"28px"} w={"28px"} bgColor={"primary"} borderRadius={"8px"}>
                    <Icon name="search" />
                </Flex>
            </Flex>
        </StyledFlex>
    </>
    )
}

export default SearchInput
